export default __webpack_public_path__ + "static/media/Lock.fed19812.svg";